<template>
  <div class="pd-x-10">
    <!-- Button to open dialog -->
    <button @click="openDialog" type="button" class="btn btn-xs btn-block mg-t-10 mg-b-10 btn-outline-primary">
      <feather type="search" size="14" class="mg-r-5"></feather>
      Хэрэглэгчээр
    </button>

    <!-- Selected user display -->
    <div v-if="selectedUser" class="mg-t-10">
      <div class="alert alert-info" role="alert">
        <div>
          <div class="d-flex align-items-center">
            <feather
              type="user"
              size="16"
              class="mg-r-10"
              style="min-width: 16px"
            ></feather>
            <div>
              <div style="line-height: 1.2; font-size: 12px; font-weight: 600;">
                {{ selectedUser.firstName }} {{ selectedUser.lastName }}
              </div>
              <span class="mg-l-10 tx-color-03">
                ({{ selectedUser.regNo }})
              </span>
            </div>
          </div>
        </div>
        <button
          @click="changeUser"
          type="button"
          style="display: block;"
          class="btn btn-block mg-t-10 btn-xs btn-outline-secondary"
        >
          <feather type="edit-2" size="12" class="mg-r-5"></feather>
          Солих
        </button>
      </div>
    </div>

    <!-- Large Dialog -->
    <b-modal
      v-model="showDialog"
      title="Хэрэглэгч хайх"
      size="xl"
      hide-footer
      centered
      body-class="pd-0"
      @hide="closeDialog"
    >
      <div class="d-flex" style="height: 70vh;">
        <!-- Left side: Search form -->
        <div class="wd-30p bd-r pd-20" style="overflow-y: auto;">
          <h6 class="tx-14 tx-semibold mg-b-15">Хайлтын шалгуур</h6>

          <!-- Овог -->
          <div class="mg-b-15">
            <label class="form-label tx-12 tx-color-03 mg-b-5">
              Овог
            </label>
            <input
              v-model="searchFields.lastName"
              @keyup.enter="performSearch"
              type="text"
              class="form-control"
              placeholder="Овог оруулна уу..."
            />
          </div>

          <!-- Нэр -->
          <div class="mg-b-15">
            <label class="form-label tx-12 tx-color-03 mg-b-5">
              Нэр
            </label>
            <input
              v-model="searchFields.firstName"
              @keyup.enter="performSearch"
              type="text"
              class="form-control"
              placeholder="Нэр оруулна уу..."
            />
          </div>

          <!-- Утас -->
          <div class="mg-b-15">
            <label class="form-label tx-12 tx-color-03 mg-b-5">
              Утас
            </label>
            <input
              v-model="searchFields.mobile"
              @keyup.enter="performSearch"
              type="text"
              class="form-control"
              placeholder="Утасны дугаар оруулна уу..."
            />
          </div>

          <!-- Регистр № -->
          <div class="mg-b-20">
            <label class="form-label tx-12 tx-color-03 mg-b-5">
              Регистр №
            </label>
            <input
              v-model="searchFields.regNo"
              @keyup.enter="performSearch"
              type="text"
              class="form-control"
              placeholder="Регистр дугаар оруулна уу..."
            />
          </div>

          <!-- Search button -->
          <div class="mg-b-20">
            <button
              @click="performSearch"
              class="btn btn-primary wd-100p"
              type="button"
            >
              <feather type="search" size="14" class="mg-r-5"></feather>
              Хайх
            </button>
          </div>

          <!-- Clear button -->
          <div class="mg-b-20">
            <button
              @click="clearSearch"
              class="btn btn-outline-secondary wd-100p"
              type="button"
            >
              <feather type="x" size="14" class="mg-r-5"></feather>
              Цэвэрлэх
            </button>
          </div>

          <!-- Search results info -->
          <div v-if="totalCount > 0" class="alert alert-success tx-12">
            <strong>{{ totalCount }}</strong> хэрэглэгч олдлоо
          </div>
          <div
            v-if="hasSearchValues && totalCount === 0 && !isSearching"
            class="alert alert-warning tx-12"
          >
            Хайсан утгаар хэрэглэгч олдсонгүй
          </div>
        </div>

        <!-- Right side: User list -->
        <div class="flex-fill" style="overflow-y: auto;">
          <div class="pd-20">
            <h6 class="tx-14 tx-semibold mg-b-15">Хэрэглэгчийн жагсаалт</h6>

            <div v-if="isSearching" class="text-center pd-y-40">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Хайж байна...</span>
              </div>
              <p class="mg-t-10 tx-12 tx-color-03">Хайж байна...</p>
            </div>

            <div v-else-if="userList.length === 0" class="text-center pd-y-40">
              <feather type="users" size="48" class="tx-color-03"></feather>
              <p class="mg-t-10 tx-12 tx-color-03">
                Хайлт хийж үр дүнг харана уу
              </p>
            </div>

            <table v-else class="table table-hover table-bordered">
              <thead>
                <tr>
                  <th style="width: 50px;">№</th>
                  <th>Овог</th>
                  <th>Нэр</th>
                  <th>Утас</th>
                  <th>Регистр №</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(user, index) in userList"
                  :key="user.userTaskId"
                  @click="selectUser(user)"
                  class="is-pointer"
                  :class="{
                    'table-active':
                      selectedUser &&
                      selectedUser.userTaskId === user.userTaskId
                  }"
                  style="cursor: pointer;"
                >
                  <td>{{ (pageNumber - 1) * pageSize + index + 1 }}</td>
                  <td>
                    <strong>{{ user.lastName || "-" }}</strong>
                  </td>
                  <td>
                    <strong>{{ user.firstName || "-" }}</strong>
                  </td>
                  <td>{{ user.mobile || "-" }}</td>
                  <td>{{ user.regNo || "-" }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Pagination -->
            <div
              v-if="userList.length > 0"
              class="d-flex justify-content-between align-items-center mg-t-20 pd-t-20 bd-t"
            >
              <div class="d-flex align-items-center">
                <span class="tx-12 tx-color-03 mg-r-10">
                  Нийт: <strong>{{ totalCount }}</strong>
                </span>
                <span class="tx-12 tx-color-03 mg-r-15">
                  Хуудас:
                  <strong>{{ pageNumber }}</strong> /
                  <strong>{{ totalPages }}</strong>
                </span>
                <label class="tx-12 tx-color-03 mg-r-5">Хуудасны хэмжээ:</label>
                <select
                  v-model="pageSize"
                  @change="onPageSizeChange"
                  class="form-control form-control-sm"
                  style="width: 80px;"
                >
                  <option :value="5">5</option>
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <nav>
                <ul class="pagination pagination-sm mg-b-0">
                  <li class="page-item" :class="{ disabled: pageNumber === 1 }">
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(1)"
                      aria-label="Эхний хуудас"
                    >
                      <span aria-hidden="true">&laquo;&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: pageNumber === 1 }">
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(pageNumber - 1)"
                      aria-label="Өмнөх хуудас"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li
                    v-for="page in visiblePages"
                    :key="page"
                    class="page-item"
                    :class="{ active: page === pageNumber }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(page)"
                    >
                      {{ page }}
                    </a>
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: pageNumber === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(pageNumber + 1)"
                      aria-label="Дараагийн хуудас"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: pageNumber === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="goToPage(totalPages)"
                      aria-label="Сүүлийн хуудас"
                    >
                      <span aria-hidden="true">&raquo;&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { getToken } from "@/libs/util";
import { mapActions } from "vuex";

export default {
  name: "userChooser",
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    projectId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      searchFields: {
        firstName: "",
        lastName: "",
        mobile: "",
        regNo: ""
      },
      userList: [],
      selectedUser: null,
      isSearching: false,
      pageNumber: 1,
      pageSize: 10,
      totalCount: 0
    };
  },
  computed: {
    hasSearchValues() {
      return (
        this.searchFields.firstName.trim() !== "" ||
        this.searchFields.lastName.trim() !== "" ||
        this.searchFields.mobile.trim() !== "" ||
        this.searchFields.regNo.trim() !== ""
      );
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize) || 1;
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.pageNumber - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start < maxVisible - 1) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.loadUsers();
      }
    }
  },
  methods: {
    ...mapActions(["handleLoading", "handleUserInfoModal"]),
    openDialog() {
      this.showDialog = true;
      this.clearSearch();
      this.pageNumber = 1;
      this.totalCount = 0;
    },
    closeDialog() {
      this.showDialog = false;
      //this.clearSearch();
      this.userList = [];
      this.pageNumber = 1;
      this.totalCount = 0;
    },
    clearSearch() {
      this.searchFields = {
        firstName: "",
        lastName: "",
        mobile: "",
        regNo: ""
      };
      // Сонгогдсон хэрэглэгчийг арилгах
      this.selectedUser = null;
      this.$emit("input", null);
    },
    changeUser() {
      this.selectedUser = null;
      this.$emit("input", null);
      this.openDialog();
    },
    loadUsers() {
      if (!this.projectId) {
        return;
      }

      this.isSearching = true;

      const params = [
        {
          name: "projectId",
          value: String(this.projectId)
        },
        {
          name: "pagenumber",
          value: String(this.pageNumber)
        },
        {
          name: "pagesize",
          value: String(this.pageSize)
        },
        {
          name: "firstName",
          value: this.searchFields.firstName.trim()
        },
        {
          name: "lastName",
          value: this.searchFields.lastName.trim()
        },
        {
          name: "mobile",
          value: this.searchFields.mobile.trim()
        },
        {
          name: "regNo",
          value: this.searchFields.regNo.trim()
        }
      ];

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getToken()
        }
      };

      // Load users
      const usersRequest = {
        procName: "[dbo].[sp_GetProjectTaskUsers]",
        exportMode: 2,
        params: params
      };

      // Load total count
      const countRequest = {
        procName: "[dbo].[sp_GetProjectTaskUsersCount]",
        exportMode: 2,
        params: params
      };

      Promise.all([
        Axios.post(
          "https://app.gosmart.mn/coreDev/reportV2/Export",
          usersRequest,
          config
        ),
        Axios.post(
          "https://app.gosmart.mn/coreDev/reportV2/Export",
          countRequest,
          config
        )
      ])
        .then(([usersRes, countRes]) => {
          this.isSearching = false;

          // Handle users response
          if (
            usersRes.data &&
            usersRes.data.code === 200 &&
            usersRes.data.data
          ) {
            this.userList = usersRes.data.data;
          } else {
            this.userList = [];
          }

          // Handle count response
          if (
            countRes.data &&
            countRes.data.code === 200 &&
            countRes.data.data &&
            countRes.data.data.length > 0
          ) {
            this.totalCount = countRes.data.data[0].totalCount || 0;
          } else {
            this.totalCount = 0;
          }
        })
        .catch(error => {
          this.isSearching = false;
          this.userList = [];
          this.totalCount = 0;
          console.error("Error loading users:", error);
        });
    },
    onPageSizeChange() {
      this.pageNumber = 1;
      this.loadUsers();
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.pageNumber) {
        this.pageNumber = page;
        this.loadUsers();
      }
    },
    performSearch() {
      this.pageNumber = 1;
      this.loadUsers();
    },
    selectUser(user) {
      this.selectedUser = user;
      this.$emit("input", user.userId);
      this.$emit("on-user-selected", user);
      this.closeDialog();
    }
  }
};
</script>

<style scoped>
.is-pointer {
  cursor: pointer;
}

.is-pointer:hover {
  background-color: #f8f9fa;
}

.table-active {
  background-color: #e7f3ff !important;
}

.bd-r {
  border-right: 1px solid #dee2e6;
}
</style>
